import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceLogComponent } from './device-log/device-log.component';
import { QueryLogComponent } from './query-log/query-log.component';
import { SessionLogComponent } from './session-log/session-log.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRippleModule } from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PipesModule } from 'app/pipes/pipes.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { TranslateModule } from '@ngx-translate/core';
import { AgmCoreModule } from '@agm/core';
import { LogsService } from 'app/services/logs.service';
import { DateConvertService } from 'app/services/date-convert.service';
import { DriverProcessComponent } from './driver-process/driver-process.component';
import { DriverProcessDetailComponent } from './driver-process/driver-process-detail/driver-process-detail.component';
import { DriverProcessService } from 'app/services/driver-process.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserModule } from '@angular/platform-browser';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouteHistoryComponent } from './driver-process/route-history/route-history.component';



@NgModule({
  declarations: [DeviceLogComponent, QueryLogComponent, SessionLogComponent, DriverProcessComponent, DriverProcessDetailComponent,RouteHistoryComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    MatTableModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    MatChipsModule,
    MatExpansionModule,
    MatInputModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatProgressBarModule,
    BrowserModule,
    MatRippleModule,
    MatSortModule,
    MatTabsModule,
    MatSnackBarModule,
    PipesModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TranslateModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
  })
  ],
  providers:[LogsService,DateConvertService,DriverProcessService]
})
export class LogsModule { }
